(function($){




/*
    $(document).ready(function () {

        $(document).on('click', '.notifyme > a', function(e){
            e.preventDefault();
            e.stopPropagation();
            $(this).parent().find('form').fadeToggle();
        });

        $(document).on('click', '.notifyme form a.submit', function(e){
            e.preventDefault();
            e.stopPropagation();
            var form = $(this).closest('form');
            data = {};
            data.action = 'bigcommerce_notifyme';
            data.sku = form.find('input[name="sku"]').val();
            data.email = form.find('input[name="email"]').val();
            jQuery.post( ajax, data, function ( response ) {
                form.find('p.error').html('');
                form.find('p.success').html('');
                if(response.success != '') form.find('p.success').html(response.success);
                if(response.error != '') form.find('p.error').html(response.error);
            } );
        });

        $('.geoBlockUS.hasSKU').each(function () {
            var blk = $(this);
            data = {};
            data.action = 'bigcommerce_live_update';
            data.sku = blk.attr('data-sku');
            jQuery.post( ajax, data, function ( response ) {
                if(response.html != ''){
                    blk.html(response.html);
                }
            } );
        });
    }); */

})(jQuery);